import React from "react";

import { ComponentsLoader } from "components";
import { Table } from "..";
import type { ITableHead } from "../DefaultTable/Table";

interface ITableWrapperProps {
    pagination?: React.ReactElement,
    header?: React.ReactElement,
    data: Array<string | number | {[key: string]: any}> | null,
    head: Array<ITableHead>,
    className?: string,
    isLoading: boolean,
    error: string | null
}

const TableWrapper: React.FC<ITableWrapperProps> = ({
    pagination,
    header,
    data,
    head,
    className,
    isLoading,
    error
}) => {
    return (
        <div className={`bg-c-light-gray dark:bg-c-light-black ${className}`}>
            {header && header}
                <div className="max-w-full overflow-auto min-h-[540px]">
                    {
                        isLoading ?
                        <ComponentsLoader />
                        : error ?
                        <div className="text-xs text-red-500">{error}</div>
                        :
                        data && head &&
                        <Table 
                            data={data}
                            head={head}
                        />
                    }
                </div>
            {pagination && pagination}
        </div>
    )
}

export default TableWrapper;